module.exports = __webpack_public_path__ + "img/vertical_4_6_1.458f7399.png";